import './PickUpFromStoreList.scss';

import { any, object, string } from 'prop-types';
import React, { Fragment, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import { setCartLineFullfillment } from '@redux/actions/cartDetail';
import { getAvailabilityStoresSelector } from '@redux/reducers/bopis/getAvailabilityStores/selector';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useDidUpdateEffect } from '@utils/customsHook/useDidUpdateEffect';

import PickupFromStore from '../../../BuyingOptions/BOShippingInfo/PickupFromStore';

const PickUpFromStoreList = ({
  layoutData,
  cartData
}) => {
  const MAX_STORE_SHOWING_ON_LIST = 3;
  const dispatch = useDispatch();

  const {
    isFetchingStores,
    data: availabilityStoresList
  } = useSelector(getAvailabilityStoresSelector);
  const productsList = useMemo(() => cartData?.PickUpStore || [], [cartData]);
  const selectedAddress = useMemo(() => productsList?.[0]?.Address, [productsList]);

  const mappingAvailabilityStoresList = useMemo(() => {
    const tempData = [...availabilityStoresList].map((item) => (
      {
        ...item,
        isSelected: item?.OutletId === selectedAddress?.PickUpStoreId
      }
    ));

    return tempData.sort((a, b) => {
      if (a.isSelected === b.isSelected) return 0;
      if (a.isSelected) return -1;
      else return 1;
    });
  }, [availabilityStoresList, selectedAddress]);

  useDidUpdateEffect(() => {
    /** INFO: handle set first store as default is no store was selected */
    if (mappingAvailabilityStoresList.length) {
      const isHasStoreSelected = mappingAvailabilityStoresList.some((store) => store.isSelected);
      if (!isHasStoreSelected) {
        handleSelectStore(mappingAvailabilityStoresList?.[0]);
      }
    }
  }, [mappingAvailabilityStoresList, selectedAddress]);

  function handleSelectStore (storeItem) {
    // eslint-disable-next-line no-unused-vars
    const {
      OutletId,
      Name,
      Street,
      Phone,
      ...restData
    } = storeItem;
    const cartLinesData = cartData?.PickUpStore || [];

    dispatch(setCartLineFullfillment({
      updateCartLineFulfillmentPayload: {
        ...restData,
        AddressName: Name || '',
        Address1: Street || '',
        PhoneNumber: Phone || '',
        CartLineIds: [...cartLinesData.map((line) => line?.ExternalCartLineId)],
        DeliveryOptionId: cartLinesData?.[0]?.DeliveryOptionId || '',
        ExpressStoreId: OutletId || '',
        IsBilling: false,
        IsPrimary: false
      }
    }));
  }

  return !isFetchingStores ? availabilityStoresList.length ? (
    <>
      <ul className='address-component__list'>
        {mappingAvailabilityStoresList.map((store, index) =>
          index < MAX_STORE_SHOWING_ON_LIST ? (
            <li
              key={store.OutletId}
              className={[
                'address-component__list__item',
                selectedAddress?.PickUpStoreId === store.OutletId ? 'selected' : ''
              ].join(' ')}
              onClick={() => handleSelectStore(store)}
            >
              <span className='item-name'>
                <strong>{store.Name},{' '}</strong>
                <span dangerouslySetInnerHTML={{ __html: store.FullAddress }} />
              </span>
            </li>
          ) : (
            <Fragment key={store.OutletId} />
          )
        )}
      </ul>
      {availabilityStoresList.length > MAX_STORE_SHOWING_ON_LIST ? (
        <PickupFromStore
          addressSetting={layoutData?.['BOPIS Address Settings']}
          isShowIcon={false}
          openStoresListModalLabel={(
            <Text
              tag='p'
              field={layoutData?.['BOPIS See More Store Text']}
              className='address-component__button-see-more'
            />
          )}
          selectStoreButtonLabel={layoutData['PopUp Select Label'].value}
          onStoreSelect={handleSelectStore}
        />
      ) : (
        <></>
      )}
    </>
  ) : (
    <></>
  ) : (
    <ul className='address-component__list'>
      {Array.from(new Array(3)).map((_, index) => (
        <li key={index} className='bopis-bo-info-skeleton'></li>
      ))}
    </ul>
  );
};

PickUpFromStoreList.propTypes = {
  layoutData: any,
  type: string,
  cartData: object
};

const mapStateToProps = (state) => {
  const currentCustomCart = state.productReducer.cartDetailReducer.currentCartCustom || null;
  const clientSOCartCustomData = state.personalizeOfferReducer.getClientSOCartReducer.customData || null;

  return {
    cartData: clientSOCartCustomData || currentCustomCart
  };
};

export default connect(mapStateToProps)(PickUpFromStoreList);